module.exports = __webpack_public_path__ + "static/media/2.4deef4a9.jpg";